import { IFilterSet, TAllFilter } from 'shared/types/filters';
import { BED_FILTERS_SET } from './bed';
import { MIXED_FLAT_FILTERS_SET } from './mixedFlat';
import { FLAT_OLD_FILTERS_SET } from './flatOld';
import { NEWBUILDING_FILTERS_SET } from './newbuilding';
import { ROOM_FILTERS_SET } from './room';
import { FLAT_SHARED_FILTERS_SET } from './flatShared';
import { MIXED_SUBURBAN_FILTERS_SET } from './mixedSuburban';
import { HOUSE_FILTERS_SET } from './house';
import { LAND_FILTERS_SET } from './land';
import { GARAGE_FILTERS_SET } from './garage';
import { OTHER_FILTERS_SET } from './other';

export const ALL_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  ...FLAT_OLD_FILTERS_SET,
  ...NEWBUILDING_FILTERS_SET,
  ...FLAT_SHARED_FILTERS_SET,
  ...ROOM_FILTERS_SET,
  ...BED_FILTERS_SET,
  ...HOUSE_FILTERS_SET,
  ...LAND_FILTERS_SET,
  ...GARAGE_FILTERS_SET,
  ...MIXED_FLAT_FILTERS_SET,
  ...MIXED_SUBURBAN_FILTERS_SET,
  ...OTHER_FILTERS_SET,
];
